import { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import PostcodeCouponsMap from "./PostcodeCouponsMap";

const isDev = import.meta.env.DEV;

export default function PublicMapWrapper({ userLocation }) {
  const [region, setRegion] = useState(() => {
    const saved = sessionStorage.getItem("mapRegion");

    if (!saved || !/^[A-Z]{1,2}$/.test(saved)) {
      sessionStorage.setItem("mapRegion", "PR");
      return "PR";
    }

    return saved;
  });

  useEffect(() => {
    if (!region || !/^[A-Z]{1,2}$/.test(region)) {
      sessionStorage.setItem("mapRegion", "PR");
      setRegion("PR");
      return;
    }

    sessionStorage.setItem("mapRegion", region);

    if (isDev) console.log("[PublicMapWrapper] region:", region);
  }, [region]);

  return (
    <Box w="100%" overflow="visible">
      {/* Reset Map button removed */}

      <Box overflow="visible">
        <PostcodeCouponsMap
          authId={undefined}
          flyerId={null}
          region={region}
          setRegionOverride={setRegion}
          userLocation={userLocation}
        />
      </Box>
    </Box>
  );
}
